import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { ApiService } from 'app/shared/services/api/api.service';

@Component({
  selector: 'app-sample-order-create',
  templateUrl: './sample-order-create.component.html'
})
export class SampleOrderCreateComponent implements OnInit {

  supplierId: number;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.supplierId = this.route.snapshot.params['supplierId'];
    this.createSampleOrder();
  }

  createSampleOrder() {
    this.apiService.getHttp('/sampleorder/' + this.supplierId + '/create').subscribe(
      (response) => {
        this.router.navigate(['/sampleorder/detail', response['sampleOrderId']]);
      });
    return
  }

}
